module.exports = __webpack_public_path__ + "img/ceshi2.fe0793b1.png";